import moment from 'moment';
import 'moment/locale/hu';

/**
 * Voiz stores the aggregation month information in `YYYY-M` or `YYYY-MM` format.
 * The format depends on the month.
 *  - If the month between January and September then uses 1 digit for month. `2022-1` for January
 *  - If the month between October and December then uses 2 digit for month. `2022-10` for October
 *  Chrome new Date(date) parses both (1 and 2 digit) format correctly, but Safari parses only the 2 digit format.
 *  This helper function will convert the voiz date to moment date.
 *  Uses moment date because later have to format it.
 *
 * @param {string} date - voiz month date
 * @returns {moment}
 */
export default function parseVoizMonthDate(date) {
  if (!date) return moment();

  const split = date.split('-');

  if (split.length < 2) throw new Error(`"${date}" is not voiz month`);

  if (split.length === 2) split[2] = '01';

  split[1] = split[1].padStart(2, '0');

  return moment(new Date(split.join('-')));
}
